import type { SVGProps } from 'react';

export const ExternalLink = (props: SVGProps<any>) => (
  <svg
    height={32}
    role="img"
    viewBox="0 0 32 32"
    width={32}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'external link'}</title>
    <g
      fill="none"
      fillRule="evenodd"
      stroke={props.fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    >
      <path d="M15.18 5H3.014a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V16.95h0M16.5 15.5l13-13" />
      <path
        d="m20 1.112 9.788-.1A1.2 1.2 0 0 1 31 2.212V12h0"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
